import { Component, Input, ViewEncapsulation  } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-partner-delete',
  templateUrl: './partner-delete.component.html',
  styleUrls: ['./partner-delete.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PartnerDeleteComponent {
  @Input() title = 'Confirm Delete';
  @Input() message = 'Are you sure?';
  @Input() cancelText = 'Cancel';
  @Input() confirmText = 'Delete';

  constructor(public offcanvas: NgbActiveOffcanvas) {}

  cancel() { this.offcanvas.dismiss(); }
  confirm() { this.offcanvas.close('confirmed'); }
}